"use strict";

import Vue from 'vue';
import axios from "axios";
import {Message} from 'element-ui'
// import store from '../store/store.js'
import qs from 'qs'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  baseURL: process.env.VUE_APP_axios_baseURL, // api的base_url
  timeout: 60 * 1000, // 请求超时时间2
  // withCredentials: true, // Check cross-site Access-Control
};

//创建Vue实例
const _axios = axios.create(config);

// request拦截器 下方注掉的是ES6的写法
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if(config.method=='post'){//是post的请求时,data中值格式不正确,所以后台接收不到,用qs转化一下就可以了
      config.data = qs.stringify(config.data)
    }
    if(config.url==='/login'||config.url==='/'){  //如果是登录操作，则不需要携带header里面的token
    }else{
      if (localStorage.getItem('Authorization')) {
        config.headers.Authorization = localStorage.getItem('Authorization');
      }
    }
    return config;
  },
  function(error) {
    // console.log("request");
    // Do something with request error
    return Promise.reject(error);
  }
);
/*ES6写法
service.interceptors.request.use(config => {
  return config
}, error => {
  console.error(error) // for debug
  Promise.reject(error)
})*/

// response拦截器
_axios.interceptors.response.use(
  response => {
    // console.log("请求有效");
    const res = response.data;
    if (res.code == '1000') {
      return res;
    }
    if (res.code == '100') {
      return res.info;
    }else {
      Message({
        message: res.msg,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res)
    }
  },
  error => {
    console.error('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
);

Plugin.install = function(Vue, options) {
  // console.log("options ----> "+options);
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
    api: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
/*export default _axios;*/